import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { PANEL_FOOTER_BACKGROUND_COLOR, PANEL_FOOTER_BORDER_COLOR } from 'HubStyleTokens/theme';
import styled from 'styled-components';
import UIAbstractPageSection from '../page/UIAbstractPageSection';
import { setTemplateMaxWidth } from '../utils/Styles';
import UIStickyFooter from './UIStickyFooter';

/** See `UIStickyFooter` for prop descriptions. */
import { jsx as _jsx } from "react/jsx-runtime";
const StickyFooter = styled(UIStickyFooter).withConfig({
  displayName: "UIFixedSaveBar__StickyFooter",
  componentId: "u86x39-0"
})(["&&{background-color:", ";border-top:1px solid ", ";box-shadow:none;padding-bottom:20px;padding-top:20px;}"], PANEL_FOOTER_BACKGROUND_COLOR, PANEL_FOOTER_BORDER_COLOR);
const PageSection = styled(UIAbstractPageSection).withConfig({
  displayName: "UIFixedSaveBar__PageSection",
  componentId: "u86x39-1"
})([".space-sword--max-width &{", "}"], setTemplateMaxWidth());
export default function UIFixedSaveBar(props) {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StickyFooter, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(PageSection, {
      children: children
    })
  }));
}
UIFixedSaveBar.propTypes = UIStickyFooter.propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIFixedSaveBar.defaultProps = UIStickyFooter.defaultProps;
UIFixedSaveBar.displayName = 'UIFixedSaveBar';